import React from 'react'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>
           Monash University : Assignment 2 FIT5225 2020 : TagStore: A Modern Image Storage on the Cloud
        </p>
      </div>
    </footer>
  )
}
